import { Pipe, PipeTransform } from '@angular/core';

import { fullName } from '@lib/utils';

@Pipe({ name: 'fullName' })
export class FullNamePipe implements PipeTransform {

  public transform(config: {
    firstName: string;
    lastName: string;
    deactivatedAt?: string;
  }): string {
    return fullName({
      first_name: config.firstName,
      last_name: config.lastName,
      deactivated_at: config.deactivatedAt,
    }, !!config.deactivatedAt);
  }
}